export default __webpack_public_path__ + "static/media/baner-charges.abc09cc8.jpg";